export const LOTTIE_ANIMATION = {
	v: '5.7.0',
	fr: 25,
	ip: 0,
	op: 270,
	w: 600,
	h: 328,
	nm: 'JSM-your-work-onboarding-601',
	ddd: 0,
	assets: [
		{
			id: 'comp_0',
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 0,
					nm: 'v2_MAIN_your-work',
					refId: 'comp_1',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [212, 142, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [848, 568, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [25, 25, 100],
							ix: 6,
						},
					},
					ao: 0,
					w: 1696,
					h: 1136,
					ip: 0,
					op: 274.166666666667,
					st: 0,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_1',
			layers: [
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'nav-line',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [847.5, 156, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [847.75, 4.25, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0],
												[0, 0],
											],
											v: [
												[-847.5, 4],
												[847.5, 4],
												[847.5, -4],
												[-847.5, -4],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.875, 0.882000014361, 0.902000038297, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 2',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [847.75, 4.25],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 274.166666666667,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 0,
					nm: '_part_Menu Active',
					refId: 'comp_2',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [388, 80, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [62, 80, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					tm: {
						a: 1,
						k: [
							{
								i: {
									x: [0.833],
									y: [0.833],
								},
								o: {
									x: [0.167],
									y: [0.167],
								},
								t: 180.833,
								s: [0],
							},
							{
								i: {
									x: [0.833],
									y: [0.833],
								},
								o: {
									x: [0.167],
									y: [0.167],
								},
								t: 193.333,
								s: [0.667],
							},
							{
								i: {
									x: [0.833],
									y: [0.833],
								},
								o: {
									x: [0.167],
									y: [0.167],
								},
								t: 201.667,
								s: [1.1],
							},
							{
								t: 305.833333333333,
								s: [4.667],
							},
						],
						ix: 2,
					},
					w: 124,
					h: 160,
					ip: 180.833333333333,
					op: 274.166666666667,
					st: 180.833333333333,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 0,
					nm: '_part_Menu Active',
					parent: 13,
					refId: 'comp_2',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 128.333,
									s: [100],
								},
								{
									t: 132.5,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [62.25, 22.228, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [62, 80, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					tm: {
						a: 1,
						k: [
							{
								i: {
									x: [0.833],
									y: [0.833],
								},
								o: {
									x: [0.167],
									y: [0.167],
								},
								t: -44.167,
								s: [1],
							},
							{
								t: -35.8333333333333,
								s: [1.333],
								h: 1,
							},
						],
						ix: 2,
					},
					w: 124,
					h: 160,
					ip: 0,
					op: 274.166666666667,
					st: -69.1666666666667,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 0,
					nm: '_part_Menu Active',
					refId: 'comp_2',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 194.167,
									s: [100],
								},
								{
									t: 195,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [588, 80, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [62, 80, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					w: 124,
					h: 160,
					ip: 130.833333333333,
					op: 240.833333333333,
					st: 115.833333333333,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 0,
					nm: 'A3_Min Project',
					refId: 'comp_4',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.999],
										y: [0.44],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 245,
									s: [100],
								},
								{
									t: 253.333333333333,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [848, 568, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [848, 568, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					w: 1696,
					h: 1136,
					ip: 195.833333333333,
					op: 255.833333333333,
					st: 195.833333333333,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 7,
					ty: 0,
					nm: 'A2_Expand Project',
					refId: 'comp_5',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 198.333,
									s: [100],
								},
								{
									t: 199.166666666667,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [848, 568, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [848, 568, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					tm: {
						a: 1,
						k: [
							{
								i: {
									x: [0.833],
									y: [0.833],
								},
								o: {
									x: [0.167],
									y: [0.167],
								},
								t: 119.167,
								s: [0],
							},
							{
								t: 178.333333333333,
								s: [2.367],
								h: 1,
							},
						],
						ix: 2,
					},
					w: 1696,
					h: 1136,
					ip: 119.166666666667,
					op: 274.166666666667,
					st: 119.166666666667,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 8,
					ty: 0,
					nm: '_part_Create Project',
					refId: 'comp_6',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.68],
										y: [0.06],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 236.667,
									s: [100],
								},
								{
									t: 245,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [1760, 568, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [848, 568, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					tm: {
						a: 1,
						k: [
							{
								i: {
									x: [0.833],
									y: [0.833],
								},
								o: {
									x: [0.167],
									y: [0.167],
								},
								t: 70.833,
								s: [0],
							},
							{
								t: 130,
								s: [2.367],
								h: 1,
							},
						],
						ix: 2,
					},
					w: 1696,
					h: 1136,
					ip: 70.8333333333333,
					op: 274.166666666667,
					st: 70.8333333333333,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 9,
					ty: 0,
					nm: '_part_Create Project',
					refId: 'comp_6',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.68],
										y: [0.06],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 240.833,
									s: [100],
								},
								{
									t: 249.166666666667,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [1304, 568, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [848, 568, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					tm: {
						a: 1,
						k: [
							{
								i: {
									x: [0.833],
									y: [0.833],
								},
								o: {
									x: [0.167],
									y: [0.167],
								},
								t: 41.667,
								s: [0],
							},
							{
								t: 100.833333333333,
								s: [2.367],
								h: 1,
							},
						],
						ix: 2,
					},
					w: 1696,
					h: 1136,
					ip: 41.6666666666667,
					op: 274.166666666667,
					st: 41.6666666666667,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 10,
					ty: 0,
					nm: '_part_Create Project',
					refId: 'comp_6',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.68],
										y: [0.06],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 245,
									s: [100],
								},
								{
									t: 253.333333333333,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [848, 568, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [848, 568, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					tm: {
						a: 1,
						k: [
							{
								i: {
									x: [0.833],
									y: [0.833],
								},
								o: {
									x: [0.167],
									y: [0.167],
								},
								t: 4.167,
								s: [0],
							},
							{
								t: 63.3333333333333,
								s: [2.367],
								h: 1,
							},
						],
						ix: 2,
					},
					w: 1696,
					h: 1136,
					ip: 4.16666666666667,
					op: 274.166666666667,
					st: 4.16666666666667,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 11,
					ty: 4,
					nm: 'nav-menu-3',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [591, 78, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [62.25, 20.25, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[11.046, 0],
												[0, 0],
												[0, 11.046],
												[-11.046, 0],
												[0, 0],
												[0, -11.046],
											],
											o: [
												[0, 0],
												[-11.046, 0],
												[0, -11.046],
												[0, 0],
												[11.046, 0],
												[0, 11.046],
											],
											v: [
												[42, 20],
												[-42, 20],
												[-62, 0],
												[-42, -20],
												[42, -20],
												[62, 0],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.875, 0.882000014361, 0.902000038297, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [62.25, 20.25],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 4,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 274.166666666667,
					st: -10,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 12,
					ty: 4,
					nm: 'nav-menu-2',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [795, 76.272, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [62.25, 20.25, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[11.046, 0],
												[0, 0],
												[0, 11.046],
												[-11.046, 0],
												[0, 0],
												[0, -11.045],
											],
											o: [
												[0, 0],
												[-11.046, 0],
												[0, -11.045],
												[0, 0],
												[11.046, 0],
												[0, 11.046],
											],
											v: [
												[42, 20],
												[-42, 20],
												[-62, 0],
												[-42, -20],
												[42, -20],
												[62, 0],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.875, 0.882000014361, 0.902000038297, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [62.25, 20.25],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 4,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 274.166666666667,
					st: -10,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 13,
					ty: 4,
					nm: 'nav-menu-1',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [388, 78.022, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [62.25, 20.25, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[11.046, 0],
												[0, 0],
												[0, 11.046],
												[-11.046, 0],
												[0, 0],
												[0, -11.045],
											],
											o: [
												[0, 0],
												[-11.046, 0],
												[0, -11.045],
												[0, 0],
												[11.046, 0],
												[0, 11.046],
											],
											v: [
												[42, 20],
												[-42, 20],
												[-62, 0],
												[-42, -20],
												[42, -20],
												[62, 0],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: {
													x: [0.833],
													y: [0.833],
												},
												o: {
													x: [0.167],
													y: [0.167],
												},
												t: -6.667,
												s: [0.875, 0.882000014361, 0.902000038297, 1],
											},
											{
												i: {
													x: [0.833],
													y: [0.833],
												},
												o: {
													x: [0.167],
													y: [0.167],
												},
												t: -2.5,
												s: [0.701960802078, 0.831372559071, 1, 1],
											},
											{
												t: 0,
												s: [0.874509871006, 0.882353007793, 0.901960849762, 1],
											},
										],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [62.25, 20.25],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 4,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 274.166666666667,
					st: -10,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 14,
					ty: 4,
					nm: 'avatar',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [1591, 80.667, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[22.091, 0],
												[0, 0],
												[0, 22.091],
												[0, 0],
												[-22.091, 0],
												[0, 0],
												[0, -22.091],
												[0, 0],
											],
											o: [
												[0, 0],
												[-22.091, 0],
												[0, 0],
												[0, -22.091],
												[0, 0],
												[22.091, 0],
												[0, 0],
												[0, 22.091],
											],
											v: [
												[0, 40],
												[0, 40],
												[-40, 0],
												[-40, 0],
												[0, -40],
												[0, -40],
												[40, 0],
												[40, 0],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.874509811401, 0.882352948189, 0.901960790157, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [0, 0],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'avatar',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 274.166666666667,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 15,
					ty: 4,
					nm: 'jsm-logo-1',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [205.474, 63.774, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
												[-1.61, 2.327],
												[0, 0],
												[7.622, -10.639],
											],
											o: [
												[0, 0],
												[-2.791, 0],
												[0, 0],
												[10.306, 7.868],
												[0, 0],
											],
											v: [
												[4.247, 25.211],
												[-17.761, 25.1],
												[-20.552, 19.449],
												[11.869, -25.211],
												[16.593, 8.367],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'gf',
									o: {
										a: 0,
										k: 100,
										ix: 10,
									},
									r: 1,
									bm: 0,
									g: {
										p: 3,
										k: {
											a: 0,
											k: [
												0.417, 0.647, 0.678, 0.729, 0.686, 0.702, 0.729, 0.773, 0.956, 0.757, 0.78,
												0.816,
											],
											ix: 9,
										},
									},
									s: {
										a: 0,
										k: [-15.903, 42.457],
										ix: 5,
									},
									e: {
										a: 0,
										k: [-6.669, 29.051],
										ix: 6,
									},
									t: 1,
									nm: 'Gradient Fill 1',
									mn: 'ADBE Vector Graphic - G-Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [0, 0],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 274.166666666667,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 16,
					ty: 4,
					nm: 'jsm-logo-2',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [226.419, 97.13, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
												[-10.306, -7.868],
												[0, 0],
												[2.791, 0],
											],
											o: [
												[0, 0],
												[-7.622, 10.638],
												[0, 0],
												[1.61, -2.327],
												[0, 0],
											],
											v: [
												[-4.247, -25.433],
												[-16.701, -8.145],
												[-11.977, 25.433],
												[20.66, -19.67],
												[17.868, -25.322],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'gf',
									o: {
										a: 0,
										k: 100,
										ix: 10,
									},
									r: 1,
									bm: 0,
									g: {
										p: 3,
										k: {
											a: 0,
											k: [
												0, 0.647, 0.678, 0.729, 0.573, 0.702, 0.729, 0.773, 1, 0.757, 0.78, 0.816,
											],
											ix: 9,
										},
									},
									s: {
										a: 0,
										k: [0.693, -11.92],
										ix: 5,
									},
									e: {
										a: 0,
										k: [4.236, 9.736],
										ix: 6,
									},
									t: 1,
									nm: 'Gradient Fill 1',
									mn: 'ADBE Vector Graphic - G-Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [0, 0],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 274.166666666667,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 17,
					ty: 4,
					nm: 'app-switcher',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [111, 83.522, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [111, 83.522, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-2.268, 0],
												[0, 0],
												[0, -2.268],
												[0, 0],
												[2.268, 0],
												[0, 0],
												[0, 2.268],
											],
											o: [
												[0, -2.232],
												[0, 0],
												[2.232, 0],
												[0, 0],
												[0, 2.232],
												[0, 0],
												[-2.232, 0],
												[0, 0],
											],
											v: [
												[16, 20.04],
												[20.04, 16],
												[27.96, 16],
												[32, 20.04],
												[32, 27.96],
												[27.96, 32],
												[20.04, 32],
												[16, 27.96],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 1,
									ty: 'sh',
									ix: 2,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-2.268, 0],
												[0, 0],
												[0, -2.268],
												[0, 0],
												[2.268, 0],
												[0, 0],
												[0, 2.268],
											],
											o: [
												[0, -2.232],
												[0, 0],
												[2.232, 0],
												[0, 0],
												[0, 2.232],
												[0, 0],
												[-2.232, 0],
												[0, 0],
											],
											v: [
												[-8, 20.04],
												[-3.96, 16],
												[3.96, 16],
												[8, 20.04],
												[8, 27.96],
												[3.96, 32],
												[-3.96, 32],
												[-8, 27.96],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 2',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 2,
									ty: 'sh',
									ix: 3,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-2.268, 0],
												[0, 0],
												[0, -2.268],
												[0, 0],
												[2.268, 0],
												[0, 0],
												[0, 2.268],
											],
											o: [
												[0, -2.232],
												[0, 0],
												[2.232, 0],
												[0, 0],
												[0, 2.236],
												[0, 0],
												[-2.236, 0],
												[0, 0],
											],
											v: [
												[-32, 20.04],
												[-27.96, 16],
												[-20.04, 16],
												[-16, 20.04],
												[-16, 27.96],
												[-20.04, 32],
												[-27.96, 32],
												[-32, 27.96],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 3',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 3,
									ty: 'sh',
									ix: 4,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-2.268, 0],
												[0, 0],
												[0, -2.268],
												[0, 0],
												[2.268, 0],
												[0, 0],
												[0, 2.268],
											],
											o: [
												[0, -2.232],
												[0, 0],
												[2.232, 0],
												[0, 0],
												[0, 2.232],
												[0, 0],
												[-2.232, 0],
												[0, 0],
											],
											v: [
												[16, -3.96],
												[20.04, -8],
												[27.96, -8],
												[32, -3.96],
												[32, 3.96],
												[27.96, 8],
												[20.04, 8],
												[16, 3.96],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 4',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 4,
									ty: 'sh',
									ix: 5,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-2.268, 0],
												[0, 0],
												[0, -2.268],
												[0, 0],
												[2.268, 0],
												[0, 0],
												[0, 2.268],
											],
											o: [
												[0, -2.232],
												[0, 0],
												[2.232, 0],
												[0, 0],
												[0, 2.236],
												[0, 0],
												[-2.236, 0],
												[0, 0],
											],
											v: [
												[16, -27.96],
												[20.04, -32],
												[27.96, -32],
												[32, -27.96],
												[32, -20.04],
												[27.96, -16],
												[20.04, -16],
												[16, -20.04],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 5',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 5,
									ty: 'sh',
									ix: 6,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-2.268, 0],
												[0, 0],
												[0, -2.268],
												[0, 0],
												[2.268, 0],
												[0, 0],
												[0, 2.268],
											],
											o: [
												[0, -2.232],
												[0, 0],
												[2.232, 0],
												[0, 0],
												[0, 2.232],
												[0, 0],
												[-2.232, 0],
												[0, 0],
											],
											v: [
												[-8, -3.96],
												[-3.96, -8],
												[3.96, -8],
												[8, -3.96],
												[8, 3.96],
												[3.96, 8],
												[-3.96, 8],
												[-8, 3.96],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 6',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 6,
									ty: 'sh',
									ix: 7,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-2.268, 0],
												[0, 0],
												[0, -2.268],
												[0, 0],
												[2.268, 0],
												[0, 0],
												[0, 2.268],
											],
											o: [
												[0, -2.232],
												[0, 0],
												[2.232, 0],
												[0, 0],
												[0, 2.236],
												[0, 0],
												[-2.236, 0],
												[0, 0],
											],
											v: [
												[-8, -27.96],
												[-3.96, -32],
												[3.96, -32],
												[8, -27.96],
												[8, -20.04],
												[3.96, -16],
												[-3.96, -16],
												[-8, -20.04],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 7',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 7,
									ty: 'sh',
									ix: 8,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-2.268, 0],
												[0, 0],
												[0, -2.268],
												[0, 0],
												[2.268, 0],
												[0, 0],
												[0, 2.268],
											],
											o: [
												[0, -2.232],
												[0, 0],
												[2.232, 0],
												[0, 0],
												[0, 2.236],
												[0, 0],
												[-2.236, 0],
												[0, 0],
											],
											v: [
												[-32, -3.96],
												[-27.96, -8],
												[-20.04, -8],
												[-16, -3.96],
												[-16, 3.96],
												[-20.04, 8],
												[-27.96, 8],
												[-32, 3.96],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 8',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 8,
									ty: 'sh',
									ix: 9,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[-2.268, 0],
												[0, 0],
												[0, -2.268],
												[0, 0],
												[2.268, 0],
												[0, 0],
												[0, 2.268],
											],
											o: [
												[0, -2.236],
												[0, 0],
												[2.236, 0],
												[0, 0],
												[0, 2.236],
												[0, 0],
												[-2.236, 0],
												[0, 0],
											],
											v: [
												[-32, -27.96],
												[-27.96, -32],
												[-20.04, -32],
												[-16, -27.96],
												[-16, -20.04],
												[-20.04, -16],
												[-27.96, -16],
												[-32, -20.04],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 9',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.874509811401, 0.882352948189, 0.901960790157, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [111, 83.522],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 10,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0],
												[0, 0],
											],
											v: [
												[-48, -48],
												[48, -48],
												[48, 48],
												[-48, 48],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [111, 83.522],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 2',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 2,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 274.166666666667,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 19,
					ty: 4,
					nm: 'screen_BG',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [847.75, 567.875, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [1688, 1128],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 20,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 8,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [0.25, 0.125],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 274.166666666667,
					st: 0,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_2',
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 0,
					nm: '_part_Click IxD',
					refId: 'comp_3',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [62, 80, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [150, 150, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [45, 45, 100],
							ix: 6,
						},
					},
					ao: 0,
					hasMask: true,
					masksProperties: [
						{
							inv: false,
							mode: 'a',
							pt: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[46.68, 0],
										[0, -46.111],
										[0, 0],
										[0, 0],
										[0, 47.222],
									],
									o: [
										[0, 0],
										[-0.556, 0],
										[0, 40.004],
										[0, 0],
										[0, 0],
										[0, -47.222],
									],
									v: [
										[233.333, 101.667],
										[58.889, 102.222],
										[12.222, 147.778],
										[57.188, 191.667],
										[232.778, 192.743],
										[287.778, 147.222],
									],
									c: true,
								},
								ix: 1,
							},
							o: {
								a: 0,
								k: 100,
								ix: 3,
							},
							x: {
								a: 0,
								k: 0,
								ix: 4,
							},
							nm: 'Mask 2',
						},
					],
					w: 300,
					h: 300,
					ip: 0,
					op: 250,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'Shape Layer 2',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [62.664, 79, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [124, 40],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 20,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: {
													x: [0.833],
													y: [0.833],
												},
												o: {
													x: [0.167],
													y: [0.167],
												},
												t: 16.667,
												s: [0.874509811401, 0.882352948189, 0.901960790157, 1],
											},
											{
												t: 20,
												s: [0.701960802078, 0.831372559071, 1, 1],
											},
										],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-0.664, -0.588],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 125,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'Shape Layer 1',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [62.664, 79, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [124, 40],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 20,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.874509803922, 0.882352941176, 0.901960784314, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-0.664, -0.588],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 125,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'tab-active',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 16.667,
									s: [0],
								},
								{
									t: 20,
									s: [100],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833,
									},
									o: {
										x: 0.167,
										y: 0.167,
									},
									t: 16.667,
									s: [62, 80.549, 0],
									to: [0, -1.417, 0],
									ti: [0, 1.417, 0],
								},
								{
									t: 25,
									s: [62, 72.049, 0],
								},
							],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [[0, 0]],
											o: [[0, 0]],
											v: [[-564, 223.451]],
											c: false,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0, 0.396078461292, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [0, 0],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Shape 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [124, 8],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 4,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0, 0.396078461292, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-0.434, 75.451],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 2,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 125,
					st: 0,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_3',
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'Shape Layer 1',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [150, 150, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									d: 1,
									ty: 'el',
									s: {
										a: 1,
										k: [
											{
												i: {
													x: [0.999, 0.999],
													y: [1, 1],
												},
												o: {
													x: [0.001, 0.001],
													y: [0, 0],
												},
												t: 0,
												s: [2.875, 2.875],
											},
											{
												i: {
													x: [0.999, 0.999],
													y: [0.44, 0.44],
												},
												o: {
													x: [0.42, 0.42],
													y: [0, 0],
												},
												t: 10,
												s: [298.875, 298.875],
											},
											{
												t: 15.8333333333333,
												s: [485.875, 485.875],
											},
										],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									nm: 'Ellipse Path 1',
									mn: 'ADBE Vector Shape - Ellipse',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0, 0.396077982585, 1, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.035294117647, 0.117647058824, 0.258823529412, 1],
										ix: 4,
									},
									o: {
										a: 1,
										k: [
											{
												i: {
													x: [0.999],
													y: [1],
												},
												o: {
													x: [0.001],
													y: [0],
												},
												t: 0,
												s: [40],
											},
											{
												i: {
													x: [0.436],
													y: [1.003],
												},
												o: {
													x: [0.42],
													y: [0],
												},
												t: 10,
												s: [50],
											},
											{
												t: 15.8333333333333,
												s: [0],
											},
										],
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [3.438, -0.562],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Ellipse 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 250,
					st: 0,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_4',
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'nav-skeleton',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.667],
										y: [1],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 0,
									s: [100],
								},
								{
									t: 3.33333333333333,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [848, 568, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [324, 24],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 16,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-642.635, 136.764],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [324, 24],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 16,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-640.717, 54.676],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 5',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 2,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [324, 24],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 16,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-641.719, -28.963],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 3,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [324, 24],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 16,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-641.707, -112.295],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 3',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 4,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [234, 21.96],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 16,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-589.268, -245.951],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 2',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 5,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [68.562, 68.562],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 12,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-770.719, -242.719],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 6,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 60,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 4,
					nm: 'YW1-project-card-sidebar Outlines 2',
					parent: 4,
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833,
									},
									o: {
										x: 0.167,
										y: 0.167,
									},
									t: 3.333,
									s: [33.75, 143.75, 0],
									to: [1.008, 0, 0],
									ti: [-1.008, 0, 0],
								},
								{
									t: 19.1666666666667,
									s: [39.8, 143.75, 0],
								},
							],
							ix: 2,
						},
						a: {
							a: 0,
							k: [34.25, 136.75, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 1,
										k: [
											{
												i: {
													x: 0.999,
													y: 1,
												},
												o: {
													x: 0.167,
													y: 0,
												},
												t: 3.333,
												s: [
													{
														i: [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
														],
														o: [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
														],
														v: [
															[291, 738.25],
															[-118.422, 738.25],
															[-118.672, -232.75],
															[290, -233],
														],
														c: true,
													},
												],
											},
											{
												t: 19.1666666666667,
												s: [
													{
														i: [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
														],
														o: [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
														],
														v: [
															[34, 136.5],
															[-34, 136.5],
															[-34, -136.5],
															[34, -136.5],
														],
														c: true,
													},
												],
											},
										],
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.875, 0.882000014361, 0.902000038297, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [34.25, 136.75],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 60,
					st: -4.16666666666667,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'YW1-project-card-bg Outlines',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [281, 393, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [188.25, 144.25, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.875, 0.882000014361, 0.902000038297, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [0, 0],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Shape 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 1,
										k: [
											{
												i: {
													x: 0.999,
													y: 1,
												},
												o: {
													x: 0.167,
													y: 0,
												},
												t: 3.333,
												s: [
													{
														i: [
															[0.625, 0],
															[0, 0],
															[0.625, 0.062],
															[0, 0],
															[-8.836, 0],
															[0, 0],
															[0, 8.837],
															[0, 0],
														],
														o: [
															[0, 0],
															[0.25, 0.25],
															[0, 0],
															[0, 8.837],
															[0, 0],
															[8.836, 0],
															[0, 0],
															[0, -0.438],
														],
														v: [
															[1417.625, -240],
															[-280.75, -240],
															[-281.125, -240.062],
															[-280, 728],
															[-264, 744],
															[1399.75, 744],
															[1415.75, 728],
															[1418, -240.062],
														],
														c: true,
													},
												],
											},
											{
												t: 19.1666666666667,
												s: [
													{
														i: [
															[8.836, 0],
															[0, 0],
															[0, -8.836],
															[0, 0],
															[-8.836, 0],
															[0, 0],
															[0, 8.837],
															[0, 0],
														],
														o: [
															[0, 0],
															[-8.836, 0],
															[0, 0],
															[0, 8.837],
															[0, 0],
															[8.836, 0],
															[0, 0],
															[0, -8.836],
														],
														v: [
															[172, -144],
															[-172, -144],
															[-188, -128],
															[-188, 128],
															[-172, 144],
															[172, 144],
															[188, 128],
															[188, -128],
														],
														c: true,
													},
												],
											},
										],
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 1,
									ty: 'sh',
									ix: 2,
									ks: {
										a: 1,
										k: [
											{
												i: {
													x: 0.999,
													y: 1,
												},
												o: {
													x: 0.167,
													y: 0,
												},
												t: 3.333,
												s: [
													{
														i: [
															[0, 0],
															[0.25, 0.125],
															[0, 0],
															[4.411, 0],
															[0, 0],
															[0, 4.411],
															[0, 0],
															[0.25, 0],
														],
														o: [
															[4.411, 0],
															[0, 0],
															[0, 4.411],
															[0, 0],
															[-4.411, 0],
															[0, 0],
															[0.25, 0.375],
															[0, 0],
														],
														v: [
															[1409.562, -233],
															[1410, -233.125],
															[1407.75, 730],
															[1399.75, 738],
															[-265, 738],
															[-273, 730],
															[-273.5, -233.625],
															[-273.25, -232.062],
														],
														c: true,
													},
												],
											},
											{
												t: 19.1666666666667,
												s: [
													{
														i: [
															[0, 0],
															[0, -4.411],
															[0, 0],
															[4.411, 0],
															[0, 0],
															[0, 4.411],
															[0, 0],
															[-4.411, 0],
														],
														o: [
															[4.411, 0],
															[0, 0],
															[0, 4.411],
															[0, 0],
															[-4.411, 0],
															[0, 0],
															[0, -4.411],
															[0, 0],
														],
														v: [
															[172, -136],
															[180, -128],
															[180, 128],
															[172, 136],
															[-172, 136],
															[-180, 128],
															[-180, -128],
															[-172, -136],
														],
														c: true,
													},
												],
											},
										],
										ix: 2,
									},
									nm: 'Path 2',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'mm',
									mm: 1,
									nm: 'Merge Paths 1',
									mn: 'ADBE Vector Filter - Merge',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.875, 0.882000014361, 0.902000038297, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [188.25, 144.25],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 4,
							cix: 2,
							bm: 0,
							ix: 2,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 1,
										k: [
											{
												i: {
													x: [0.999, 0.999],
													y: [1, 1],
												},
												o: {
													x: [0.167, 0.167],
													y: [0, 0],
												},
												t: 3.333,
												s: [1687.784, 977.941],
											},
											{
												t: 19.1666666666667,
												s: [360.784, 271.941],
											},
										],
										ix: 2,
									},
									p: {
										a: 1,
										k: [
											{
												i: {
													x: 0.999,
													y: 1,
												},
												o: {
													x: 0.167,
													y: 0,
												},
												t: 3.333,
												s: [3, 16],
												to: [-95.833, -44.333],
												ti: [95.833, 44.333],
											},
											{
												t: 19.1666666666667,
												s: [-572, -250],
											},
										],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [758.816, 392.707],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 3,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 60,
					st: -4.16666666666667,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_5',
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 0,
					nm: '_part_Click IxD',
					refId: 'comp_3',
					sr: 0.8,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [268, 392, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [150, 150, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [182, 182, 100],
							ix: 6,
						},
					},
					ao: 0,
					hasMask: true,
					masksProperties: [
						{
							inv: false,
							mode: 'a',
							pt: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									o: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									v: [
										[255.233, 75.275],
										[59.341, 76.374],
										[59.341, 224.957],
										[255.782, 225.506],
									],
									c: true,
								},
								ix: 1,
							},
							o: {
								a: 0,
								k: 100,
								ix: 3,
							},
							x: {
								a: 0,
								k: 4,
								ix: 4,
							},
							nm: 'Mask 2',
						},
					],
					w: 300,
					h: 300,
					ip: 0,
					op: 200,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'nav-skeleton',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.667],
										y: [1],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 30,
									s: [0],
								},
								{
									t: 33.3333333333333,
									s: [100],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [848, 568, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [324, 24],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 16,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-642.635, 136.764],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 6',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [324, 24],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 16,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-640.717, 54.676],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 5',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 2,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [324, 24],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 16,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-641.719, -28.963],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 4',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 3,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [324, 24],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 16,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-641.707, -112.295],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 3',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 4,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [234, 21.96],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 16,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-589.268, -245.951],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 2',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 5,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 0,
										k: [68.562, 68.562],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 0,
										k: 12,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-770.719, -242.719],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 6,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 30,
					op: 90,
					st: 30,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'YW1-project-card-sidebar Outlines',
					parent: 5,
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833,
									},
									o: {
										x: 0.167,
										y: 0.167,
									},
									t: 0,
									s: [38.75, 143.75, 0],
									to: [0.167, 0, 0],
									ti: [0.333, 0, 0],
								},
								{
									i: {
										x: 0.833,
										y: 0.833,
									},
									o: {
										x: 0.167,
										y: 0.167,
									},
									t: 15,
									s: [39.75, 143.75, 0],
									to: [-0.333, 0, 0],
									ti: [0.5, 0, 0],
								},
								{
									t: 33.3333333333333,
									s: [36.75, 143.75, 0],
								},
							],
							ix: 2,
						},
						a: {
							a: 0,
							k: [34.25, 136.75, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 1,
										k: [
											{
												i: {
													x: 0.74,
													y: 1,
												},
												o: {
													x: 0.167,
													y: 0,
												},
												t: 0,
												s: [
													{
														i: [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
														],
														o: [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
														],
														v: [
															[36.75, 136.5],
															[-31.25, 136.5],
															[-31.25, -136.5],
															[36.75, -136.5],
														],
														c: true,
													},
												],
											},
											{
												i: {
													x: 0.16,
													y: 1,
												},
												o: {
													x: 0.32,
													y: 0.94,
												},
												t: 15,
												s: [
													{
														i: [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
														],
														o: [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
														],
														v: [
															[34, 136.5],
															[-34, 136.5],
															[-34, -136.5],
															[34, -136.5],
														],
														c: true,
													},
												],
											},
											{
												t: 33.3333333333333,
												s: [
													{
														i: [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
														],
														o: [
															[0, 0],
															[0, 0],
															[0, 0],
															[0, 0],
														],
														v: [
															[287, 738.25],
															[-122.422, 738.25],
															[-124.177, -239.271],
															[284.495, -239.521],
														],
														c: true,
													},
												],
											},
										],
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.875, 0.882000014361, 0.902000038297, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [35.266, 136.75],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [99.685, 99.685],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 60,
					st: -4.16666666666667,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'YW1-project-card-bg Outlines',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [281, 393, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [188.25, 144.25, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 1,
										k: [
											{
												i: {
													x: 0.16,
													y: 1,
												},
												o: {
													x: 0.32,
													y: 0.94,
												},
												t: 15,
												s: [
													{
														i: [
															[8.836, 0],
															[0, 0],
															[0, -8.836],
															[0, 0],
															[-8.836, 0],
															[0, 0],
															[0, 8.837],
															[0, 0],
														],
														o: [
															[0, 0],
															[-8.836, 0],
															[0, 0],
															[0, 8.837],
															[0, 0],
															[8.836, 0],
															[0, 0],
															[0, -8.836],
														],
														v: [
															[172, -144],
															[-172, -144],
															[-188, -128],
															[-188, 128],
															[-172, 144],
															[172, 144],
															[188, 128],
															[188, -128],
														],
														c: true,
													},
												],
											},
											{
												t: 33.3333333333333,
												s: [
													{
														i: [
															[-0.25, 0.25],
															[0, 0],
															[1, 0],
															[0, 0],
															[-8.836, 0],
															[0, 0],
															[0, 8.837],
															[0, 0],
														],
														o: [
															[0, 0],
															[0.75, 0],
															[0, 0],
															[0, 8.837],
															[0, 0],
															[8.836, 0],
															[0, 0],
															[0, 0.25],
														],
														v: [
															[1410.25, -239],
															[-280.25, -240],
															[-280.75, -240],
															[-281, 728],
															[-264, 743],
															[1399.25, 743.5],
															[1415.25, 728],
															[1415.5, -239.75],
														],
														c: true,
													},
												],
											},
										],
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 1,
									ty: 'sh',
									ix: 2,
									ks: {
										a: 1,
										k: [
											{
												i: {
													x: 0.16,
													y: 1,
												},
												o: {
													x: 0.32,
													y: 0.94,
												},
												t: 15,
												s: [
													{
														i: [
															[0, 0],
															[0, -4.411],
															[0, 0],
															[4.411, 0],
															[0, 0],
															[0, 4.411],
															[0, 0],
															[-4.411, 0],
														],
														o: [
															[4.411, 0],
															[0, 0],
															[0, 4.411],
															[0, 0],
															[-4.411, 0],
															[0, 0],
															[0, -4.411],
															[0, 0],
														],
														v: [
															[172, -136],
															[180, -128],
															[180, 128],
															[172, 136],
															[-172, 136],
															[-180, 128],
															[-180, -128],
															[-172, -136],
														],
														c: true,
													},
												],
											},
											{
												t: 33.3333333333333,
												s: [
													{
														i: [
															[0, 0],
															[0.75, -0.5],
															[0, 0],
															[4.411, 0],
															[0, 0],
															[0, 4.411],
															[0, 0],
															[-0.25, 0],
														],
														o: [
															[0.25, -0.25],
															[0, 0],
															[0, 4.411],
															[0, 0],
															[-4.411, 0],
															[0, 0],
															[0, -0.188],
															[0, 0],
														],
														v: [
															[1406.125, -238.625],
															[1405.875, -227.375],
															[1403.625, 727.625],
															[1395.875, 734.375],
															[-262.375, 732.375],
															[-268.625, 727.125],
															[-270.125, -227.688],
															[-270, -239.125],
														],
														c: true,
													},
												],
											},
										],
										ix: 2,
									},
									nm: 'Path 2',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'mm',
									mm: 1,
									nm: 'Merge Paths 1',
									mn: 'ADBE Vector Filter - Merge',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.875, 0.882000014361, 0.902000038297, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [188.25, 144.25],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 4,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 1,
										k: [
											{
												i: {
													x: [0.24, 0.24],
													y: [1, 1],
												},
												o: {
													x: [0.001, 0.001],
													y: [0, 0],
												},
												t: 15,
												s: [360.784, 271.941],
											},
											{
												t: 26.6666666666667,
												s: [1687.784, 977.941],
											},
										],
										ix: 2,
									},
									p: {
										a: 1,
										k: [
											{
												i: {
													x: 0.24,
													y: 1,
												},
												o: {
													x: 0.001,
													y: 0,
												},
												t: 15,
												s: [-572, -250],
												to: [93.5, 41.167],
												ti: [-93.5, -41.167],
											},
											{
												t: 26.6666666666667,
												s: [-11, -3],
											},
										],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.874509983437, 0.882353001015, 0.901961023667, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 0,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [758.816, 392.707],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [99.911, 99.31],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 2,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 60,
					st: -4.16666666666667,
					bm: 0,
				},
			],
		},
		{
			id: 'comp_6',
			layers: [
				{
					ddd: 0,
					ind: 1,
					ty: 4,
					nm: 'YW1-project-card-bg Outlines',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.34],
										y: [1],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 30.833,
									s: [0],
								},
								{
									t: 31.6666666666667,
									s: [100],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [281, 393, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [188.25, 144.25, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[8.836, 0],
												[0, 0],
												[0, -8.836],
												[0, 0],
												[-8.836, 0],
												[0, 0],
												[0, 8.837],
												[0, 0],
											],
											o: [
												[0, 0],
												[-8.836, 0],
												[0, 0],
												[0, 8.837],
												[0, 0],
												[8.836, 0],
												[0, 0],
												[0, -8.836],
											],
											v: [
												[172, -144],
												[-172, -144],
												[-188, -128],
												[-188, 128],
												[-172, 144],
												[172, 144],
												[188, 128],
												[188, -128],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ind: 1,
									ty: 'sh',
									ix: 2,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, -4.411],
												[0, 0],
												[4.411, 0],
												[0, 0],
												[0, 4.411],
												[0, 0],
												[-4.411, 0],
											],
											o: [
												[4.411, 0],
												[0, 0],
												[0, 4.411],
												[0, 0],
												[-4.411, 0],
												[0, 0],
												[0, -4.411],
												[0, 0],
											],
											v: [
												[172, -136],
												[180, -128],
												[180, 128],
												[172, 136],
												[-172, 136],
												[-180, 128],
												[-180, -128],
												[-172, -136],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 2',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'mm',
									mm: 1,
									nm: 'Merge Paths 1',
									mn: 'ADBE Vector Filter - Merge',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.875, 0.882000014361, 0.902000038297, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [188.25, 144.25],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 4,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 29.1666666666667,
					op: 60,
					st: 25,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 2,
					ty: 4,
					nm: 'YW1-project-card-sidebar Outlines',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.001],
										y: [0],
									},
									t: 29.167,
									s: [0],
								},
								{
									t: 31.6666666666667,
									s: [100],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 1,
							k: [
								{
									i: {
										x: 0.833,
										y: 0.833,
									},
									o: {
										x: 0.001,
										y: 0.001,
									},
									t: 29.167,
									s: [134.5, 392.5, 0],
									to: [0, 0, 0],
									ti: [0, 0, 0],
								},
								{
									t: 30.8333333333333,
									s: [134.5, 392.5, 0],
								},
							],
							ix: 2,
						},
						a: {
							a: 0,
							k: [34.25, 136.75, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[0, 0],
												[0, 0],
												[0, 0],
												[0, 0],
											],
											o: [
												[0, 0],
												[0, 0],
												[0, 0],
												[0, 0],
											],
											v: [
												[34, 136.5],
												[-34, 136.5],
												[-34, -136.5],
												[34, -136.5],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [0.875, 0.882000014361, 0.902000038297, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [34.25, 136.75],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 29.1666666666667,
					op: 60,
					st: 25,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 3,
					ty: 0,
					nm: '_part_Click IxD',
					refId: 'comp_3',
					sr: 1,
					ks: {
						o: {
							a: 0,
							k: 100,
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [280, 393, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [150, 150, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [45, 45, 100],
							ix: 6,
						},
					},
					ao: 0,
					hasMask: true,
					masksProperties: [
						{
							inv: false,
							mode: 'a',
							pt: {
								a: 0,
								k: {
									i: [
										[62.785, -2.174],
										[0, -44.613],
										[-45.166, 0],
										[-0.518, 47.482],
									],
									o: [
										[-45.139, 1.563],
										[0, 44.613],
										[45.166, 0],
										[0.487, -44.61],
									],
									v: [
										[145.911, 60.87],
										[64.13, 151.431],
										[152.433, 238.731],
										[238.561, 154.692],
									],
									c: true,
								},
								ix: 1,
							},
							o: {
								a: 0,
								k: 100,
								ix: 3,
							},
							x: {
								a: 0,
								k: 0,
								ix: 4,
							},
							nm: 'Mask 2',
						},
					],
					w: 300,
					h: 300,
					ip: 9.16666666666667,
					op: 60,
					st: 9.16666666666667,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 4,
					ty: 4,
					nm: 'Shape Layer 1',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 30.833,
									s: [100],
								},
								{
									t: 31.6666666666667,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [847.5, 571, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [0, 0, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ty: 'rc',
									d: 1,
									s: {
										a: 1,
										k: [
											{
												i: {
													x: [0.999, 0.999],
													y: [1, 1],
												},
												o: {
													x: [0.14, 0.14],
													y: [1, 1],
												},
												t: 23.333,
												s: [83.988, 83.988],
											},
											{
												t: 31.6666666666667,
												s: [366.988, 276.988],
											},
										],
										ix: 2,
									},
									p: {
										a: 0,
										k: [0, 0],
										ix: 3,
									},
									r: {
										a: 1,
										k: [
											{
												i: {
													x: [0.999],
													y: [1],
												},
												o: {
													x: [0.14],
													y: [1],
												},
												t: 23.333,
												s: [100],
											},
											{
												t: 31.6666666666667,
												s: [16],
											},
										],
										ix: 4,
									},
									nm: 'Rectangle Path 1',
									mn: 'ADBE Vector Shape - Rect',
									hd: false,
								},
								{
									ty: 'st',
									c: {
										a: 0,
										k: [0.87450986376, 0.882353001015, 0.901960844152, 1],
										ix: 3,
									},
									o: {
										a: 0,
										k: 100,
										ix: 4,
									},
									w: {
										a: 0,
										k: 8,
										ix: 5,
									},
									lc: 1,
									lj: 1,
									ml: 4,
									bm: 0,
									nm: 'Stroke 1',
									mn: 'ADBE Vector Graphic - Stroke',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [-566.006, -176.506],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Rectangle 1',
							np: 3,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 23.3333333333333,
					op: 60,
					st: 23.3333333333333,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 5,
					ty: 4,
					nm: 'YW1-add-icon Outlines',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 0,
									s: [0],
								},
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 4.167,
									s: [100],
								},
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 23.333,
									s: [100],
								},
								{
									t: 24.1666666666667,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [281, 393, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [20.25, 20.25, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[2.209, 0],
												[0, 0],
												[0, 2.209],
												[-2.209, 0],
												[0, 0],
												[0, -2.209],
											],
											o: [
												[0, 0],
												[-2.209, 0],
												[0, -2.209],
												[0, 0],
												[2.209, 0],
												[0, 2.209],
											],
											v: [
												[16, 4],
												[-16, 4],
												[-20, 0],
												[-16, -4],
												[16, -4],
												[20, 0],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [20.25, 20.25],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[2.209, 0],
												[0, 0],
												[0, 2.209],
												[0, 0],
												[-2.209, 0],
												[0, -2.209],
												[0, 0],
											],
											o: [
												[0, 0],
												[-2.209, 0],
												[0, 0],
												[0, -2.209],
												[2.209, 0],
												[0, 0],
												[0, 2.209],
											],
											v: [
												[0, 20],
												[0, 20],
												[-4, 16],
												[-4, -16],
												[0, -20],
												[4, -16],
												[4, 16],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 0,
										k: [1, 1, 1, 1],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [20.25, 20.25],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 2',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 2,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 60,
					st: 0,
					bm: 0,
				},
				{
					ddd: 0,
					ind: 6,
					ty: 4,
					nm: 'YW1-add-circle Outlines',
					sr: 1,
					ks: {
						o: {
							a: 1,
							k: [
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 0,
									s: [0],
								},
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 4.167,
									s: [100],
								},
								{
									i: {
										x: [0.833],
										y: [0.833],
									},
									o: {
										x: [0.167],
										y: [0.167],
									},
									t: 23.333,
									s: [100],
								},
								{
									t: 24.1666666666667,
									s: [0],
								},
							],
							ix: 11,
						},
						r: {
							a: 0,
							k: 0,
							ix: 10,
						},
						p: {
							a: 0,
							k: [281, 393, 0],
							ix: 2,
						},
						a: {
							a: 0,
							k: [40.25, 40.25, 0],
							ix: 1,
						},
						s: {
							a: 0,
							k: [100, 100, 100],
							ix: 6,
						},
					},
					ao: 0,
					shapes: [
						{
							ty: 'gr',
							it: [
								{
									ind: 0,
									ty: 'sh',
									ix: 1,
									ks: {
										a: 0,
										k: {
											i: [
												[22.091, 0],
												[0, 0],
												[0, 22.091],
												[-22.091, 0],
												[0, -22.091],
											],
											o: [
												[0, 0],
												[-22.091, 0],
												[0, -22.091],
												[22.091, 0],
												[0, 22.091],
											],
											v: [
												[0, 40],
												[0, 40],
												[-40, 0],
												[0, -40],
												[40, 0],
											],
											c: true,
										},
										ix: 2,
									},
									nm: 'Path 1',
									mn: 'ADBE Vector Shape - Group',
									hd: false,
								},
								{
									ty: 'fl',
									c: {
										a: 1,
										k: [
											{
												i: {
													x: [0.833],
													y: [0.833],
												},
												o: {
													x: [0.167],
													y: [0.167],
												},
												t: 23.333,
												s: [0, 0.395999983245, 1, 1],
											},
											{
												t: 24.1666666666667,
												s: [0.874509871006, 0.882353007793, 0.901960849762, 1],
											},
										],
										ix: 4,
									},
									o: {
										a: 0,
										k: 100,
										ix: 5,
									},
									r: 1,
									bm: 0,
									nm: 'Fill 1',
									mn: 'ADBE Vector Graphic - Fill',
									hd: false,
								},
								{
									ty: 'tr',
									p: {
										a: 0,
										k: [40.25, 40.25],
										ix: 2,
									},
									a: {
										a: 0,
										k: [0, 0],
										ix: 1,
									},
									s: {
										a: 0,
										k: [100, 100],
										ix: 3,
									},
									r: {
										a: 0,
										k: 0,
										ix: 6,
									},
									o: {
										a: 0,
										k: 100,
										ix: 7,
									},
									sk: {
										a: 0,
										k: 0,
										ix: 4,
									},
									sa: {
										a: 0,
										k: 0,
										ix: 5,
									},
									nm: 'Transform',
								},
							],
							nm: 'Group 1',
							np: 2,
							cix: 2,
							bm: 0,
							ix: 1,
							mn: 'ADBE Vector Group',
							hd: false,
						},
					],
					ip: 0,
					op: 60,
					st: 0,
					bm: 0,
				},
			],
		},
	],
	layers: [
		{
			ddd: 0,
			ind: 1,
			ty: 0,
			nm: 'your-work-modal-1x',
			refId: 'comp_0',
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11,
				},
				r: {
					a: 0,
					k: 0,
					ix: 10,
				},
				p: {
					a: 0,
					k: [300, 181.977, 0],
					ix: 2,
				},
				a: {
					a: 0,
					k: [212, 142, 0],
					ix: 1,
				},
				s: {
					a: 0,
					k: [100, 100, 100],
					ix: 6,
				},
			},
			ao: 0,
			w: 424,
			h: 284,
			ip: 0,
			op: 275,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 2,
			ty: 4,
			nm: 'dropshadow',
			parent: 1,
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11,
				},
				r: {
					a: 0,
					k: 0,
					ix: 10,
				},
				p: {
					a: 0,
					k: [210.028, 129.135, 0],
					ix: 2,
				},
				a: {
					a: 0,
					k: [0, 0, 0],
					ix: 1,
				},
				s: {
					a: 0,
					k: [119.048, 119.048, 100],
					ix: 6,
				},
			},
			ao: 0,
			ef: [
				{
					ty: 25,
					nm: 'Drop Shadow',
					np: 8,
					mn: 'ADBE Drop Shadow',
					ix: 1,
					en: 1,
					ef: [
						{
							ty: 2,
							nm: 'Shadow Color',
							mn: 'ADBE Drop Shadow-0001',
							ix: 1,
							v: {
								a: 0,
								k: [0.035294119269, 0.117647059262, 0.258823543787, 1],
								ix: 1,
							},
						},
						{
							ty: 0,
							nm: 'Opacity',
							mn: 'ADBE Drop Shadow-0002',
							ix: 2,
							v: {
								a: 0,
								k: 51,
								ix: 2,
							},
						},
						{
							ty: 0,
							nm: 'Direction',
							mn: 'ADBE Drop Shadow-0003',
							ix: 3,
							v: {
								a: 0,
								k: 180,
								ix: 3,
							},
						},
						{
							ty: 0,
							nm: 'Distance',
							mn: 'ADBE Drop Shadow-0004',
							ix: 4,
							v: {
								a: 0,
								k: 4,
								ix: 4,
							},
						},
						{
							ty: 0,
							nm: 'Softness',
							mn: 'ADBE Drop Shadow-0005',
							ix: 5,
							v: {
								a: 0,
								k: 5,
								ix: 5,
							},
						},
						{
							ty: 7,
							nm: 'Shadow Only',
							mn: 'ADBE Drop Shadow-0006',
							ix: 6,
							v: {
								a: 0,
								k: 0,
								ix: 6,
							},
						},
					],
				},
			],
			shapes: [
				{
					ty: 'gr',
					it: [
						{
							ty: 'rc',
							d: 1,
							s: {
								a: 0,
								k: [348, 233.094],
								ix: 2,
							},
							p: {
								a: 0,
								k: [0, 0],
								ix: 3,
							},
							r: {
								a: 0,
								k: 4,
								ix: 4,
							},
							nm: 'Rectangle Path 1',
							mn: 'ADBE Vector Shape - Rect',
							hd: false,
						},
						{
							ty: 'tr',
							p: {
								a: 0,
								k: [1.656, 11.727],
								ix: 2,
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1,
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3,
							},
							r: {
								a: 0,
								k: 0,
								ix: 6,
							},
							o: {
								a: 0,
								k: 100,
								ix: 7,
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4,
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5,
							},
							nm: 'Transform',
						},
					],
					nm: 'Rectangle 1',
					np: 1,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: 'ADBE Vector Group',
					hd: false,
				},
				{
					ty: 'fl',
					c: {
						a: 0,
						k: [1, 1, 1, 1],
						ix: 4,
					},
					o: {
						a: 0,
						k: 100,
						ix: 5,
					},
					r: 1,
					bm: 0,
					nm: 'Fill 1',
					mn: 'ADBE Vector Graphic - Fill',
					hd: false,
				},
			],
			ip: 0,
			op: 270,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 3,
			ty: 4,
			nm: 'gradient-1',
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 80,
					ix: 11,
				},
				r: {
					a: 0,
					k: 0,
					ix: 10,
				},
				p: {
					a: 0,
					k: [296.842, 217.183, 0],
					ix: 2,
				},
				a: {
					a: 0,
					k: [0, 0, 0],
					ix: 1,
				},
				s: {
					a: 0,
					k: [49.877, 36.282, 100],
					ix: 6,
				},
			},
			ao: 0,
			shapes: [
				{
					ty: 'gr',
					it: [
						{
							ind: 0,
							ty: 'sh',
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0],
										[407.308, -236.232],
										[0, 0],
									],
									o: [
										[0, 0],
										[0, 0],
										[0, 0],
										[-324.273, 188.073],
										[0, 0],
									],
									v: [
										[-595.546, 196.715],
										[607.962, 196.715],
										[607.962, -193.42],
										[-22.045, -16.466],
										[-595.045, 52.648],
									],
									c: true,
								},
								ix: 2,
							},
							nm: 'Path 1',
							mn: 'ADBE Vector Shape - Group',
							hd: false,
						},
						{
							ty: 'gf',
							o: {
								a: 0,
								k: 100,
								ix: 10,
							},
							r: 1,
							bm: 0,
							g: {
								p: 3,
								k: {
									a: 0,
									k: [
										0, 0.753, 0.714, 0.949, 0.602, 0.753, 0.714, 0.949, 0.962, 0.753, 0.714, 0.949,
										0, 0.6, 0.602, 0.3, 0.962, 0,
									],
									ix: 9,
								},
							},
							s: {
								a: 0,
								k: [-157.152, -156.564],
								ix: 5,
							},
							e: {
								a: 0,
								k: [-104.421, 198.826],
								ix: 6,
							},
							t: 1,
							nm: 'Gradient Fill 1',
							mn: 'ADBE Vector Graphic - G-Fill',
							hd: false,
						},
						{
							ty: 'tr',
							p: {
								a: 0,
								k: [0, 0],
								ix: 2,
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1,
							},
							s: {
								a: 0,
								k: [100, 100],
								ix: 3,
							},
							r: {
								a: 0,
								k: 0,
								ix: 6,
							},
							o: {
								a: 0,
								k: 100,
								ix: 7,
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4,
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5,
							},
							nm: 'Transform',
						},
					],
					nm: 'Group 1',
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: 'ADBE Vector Group',
					hd: false,
				},
			],
			ip: 0,
			op: 270,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 4,
			ty: 4,
			nm: 'gradent-2',
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 51,
					ix: 11,
				},
				r: {
					a: 0,
					k: 0,
					ix: 10,
				},
				p: {
					a: 0,
					k: [300.073, 194.973, 0],
					ix: 2,
				},
				a: {
					a: 0,
					k: [0, 0, 0],
					ix: 1,
				},
				s: {
					a: 0,
					k: [49.873, 44.578, 100],
					ix: 6,
				},
			},
			ao: 0,
			shapes: [
				{
					ty: 'gr',
					it: [
						{
							ind: 0,
							ty: 'sh',
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0],
										[228.524, 143.915],
										[124, 13],
									],
									o: [
										[0, 0],
										[0, 0],
										[0, 0],
										[-381.325, -240.142],
										[0, 0],
									],
									v: [
										[-599.58, 211.792],
										[601.393, 209.583],
										[599.649, 25.419],
										[44.085, 18.294],
										[-600.391, -211.792],
									],
									c: true,
								},
								ix: 2,
							},
							nm: 'Path 1',
							mn: 'ADBE Vector Shape - Group',
							hd: false,
						},
						{
							ty: 'gf',
							o: {
								a: 0,
								k: 100,
								ix: 10,
							},
							r: 1,
							bm: 0,
							g: {
								p: 3,
								k: {
									a: 0,
									k: [
										0, 0.753, 0.714, 0.949, 0.377, 0.753, 0.714, 0.949, 0.602, 0.753, 0.714, 0.949,
										0, 0.5, 0.377, 0.25, 0.602, 0,
									],
									ix: 9,
								},
							},
							s: {
								a: 0,
								k: [23.023, -338.84],
								ix: 5,
							},
							e: {
								a: 0,
								k: [111.655, 311.31],
								ix: 6,
							},
							t: 1,
							nm: 'Gradient Fill 1',
							mn: 'ADBE Vector Graphic - G-Fill',
							hd: false,
						},
						{
							ty: 'tr',
							p: {
								a: 0,
								k: [0, 0],
								ix: 2,
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1,
							},
							s: {
								a: 0,
								k: [100.26, 99.573],
								ix: 3,
							},
							r: {
								a: 0,
								k: 0.036,
								ix: 6,
							},
							o: {
								a: 0,
								k: 100,
								ix: 7,
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4,
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5,
							},
							nm: 'Transform',
						},
					],
					nm: 'Group 1',
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: 'ADBE Vector Group',
					hd: false,
				},
			],
			ip: 0,
			op: 270,
			st: 0,
			bm: 0,
		},
		{
			ddd: 0,
			ind: 5,
			ty: 4,
			nm: 'background',
			sr: 1,
			ks: {
				o: {
					a: 0,
					k: 100,
					ix: 11,
				},
				r: {
					a: 0,
					k: 0,
					ix: 10,
				},
				p: {
					a: 0,
					k: [299.758, 92.803, 0],
					ix: 2,
				},
				a: {
					a: 0,
					k: [0, 0, 0],
					ix: 1,
				},
				s: {
					a: 0,
					k: [50.519, 48.558, 100],
					ix: 6,
				},
			},
			ao: 0,
			shapes: [
				{
					ty: 'gr',
					it: [
						{
							ind: 0,
							ty: 'sh',
							ix: 1,
							ks: {
								a: 0,
								k: {
									i: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									o: [
										[0, 0],
										[0, 0],
										[0, 0],
										[0, 0],
									],
									v: [
										[600, 415.331],
										[-600, 415.331],
										[-600, -290.443],
										[600, -290.443],
									],
									c: true,
								},
								ix: 2,
							},
							nm: 'Path 1',
							mn: 'ADBE Vector Shape - Group',
							hd: false,
						},
						{
							ty: 'fl',
							c: {
								a: 0,
								k: [0.321568638086, 0.262745112181, 0.666666686535, 1],
								ix: 4,
							},
							o: {
								a: 0,
								k: 100,
								ix: 5,
							},
							r: 1,
							bm: 0,
							nm: 'Fill 1',
							mn: 'ADBE Vector Graphic - Fill',
							hd: false,
						},
						{
							ty: 'tr',
							p: {
								a: 0,
								k: [0.478, 45.574],
								ix: 2,
							},
							a: {
								a: 0,
								k: [0, 0],
								ix: 1,
							},
							s: {
								a: 0,
								k: [98.968, 85.747],
								ix: 3,
							},
							r: {
								a: 0,
								k: 0,
								ix: 6,
							},
							o: {
								a: 0,
								k: 100,
								ix: 7,
							},
							sk: {
								a: 0,
								k: 0,
								ix: 4,
							},
							sa: {
								a: 0,
								k: 0,
								ix: 5,
							},
							nm: 'Transform',
						},
					],
					nm: 'Group 1',
					np: 2,
					cix: 2,
					bm: 0,
					ix: 1,
					mn: 'ADBE Vector Group',
					hd: false,
				},
			],
			ip: 0,
			op: 270,
			st: 0,
			bm: 0,
		},
	],
	markers: [],
} as const;
